import React, { useEffect, useState } from 'react';
import MaterialTable from "material-table";
import Helper from 'helpers/format.helpers';
import * as servicesBeneficiary from "services/digitalBankAccount";
import { localizationOptions } from "helpers/table.helpers";
import { ContentContainer, Toast } from 'components';
import HelperStatus from 'helpers/message.helpers';
import { ModalProps, RouteWithIdParamsType } from 'global/types/types';
import { BeneficiaryType, ParamsApproveOrReject, ParamsCancel, ParamsDelete } from 'global/types/digitalAccount.types';
import { useParams } from 'react-router';
import { MenuItem, Select, TablePagination } from '@material-ui/core';
import HasPassCode from '../../Code/codeForm';
import { useUser } from 'contexts/user';
import Button from 'components/Button/Button';
import FilterListIcon from "@material-ui/icons/FilterList";
import { optionsStatusFiltering } from '../../OptionsFields/options.status';
import { IMFAState } from 'global/interface/types';
import ApproversDetails from 'components/ApproversDetails/ApproversDetails';

//@ts-ignore
const FavoredList = (props) => {
	const { setModalProps, handleOpen, handleClose, tableRef } = props;
	const { bankAccountId } = useParams<RouteWithIdParamsType>();
	const { user } = useUser();
	const [rowsPerPage, setRowsPerPage] = useState<number>(Number(localStorage.getItem('rowsPerPage')) || 5);
	const [username, setUsername] = useState("");
	const [enableFilter, setEnableFilter] = useState(false);
	const [modalFormData, setModalFormData] = useState<IMFAState>({
		password: '',
		code: '',
		showPassword: false,
	});
	const stateRef = React.useRef<IMFAState>({
		password: '',
		code: '',
		showPassword: false,
	});
	stateRef.current = modalFormData;
	const userPoolId = window.__RUNTIME_CONFIG__.REACT_APP_USER_POOL_ID;
	const cognitoClientId = window.__RUNTIME_CONFIG__.REACT_APP_USER_CLIENT_ID;

	const onRowsPerPageChange = (page: number) => {
		setRowsPerPage(page);
		localStorage.setItem('rowsPerPage', String(page));
	};

	const defaultModalProps = {
		title: 'Aprovar Favorecido',
		subtitle: 'Tem certeza que deseja  aprovar o favorecido?',
		onClick: () => { },
		buttonText: "Confirmar",
		children: <HasPassCode setFormData={(data: IMFAState) => { setModalFormData(data); }} />
	} as ModalProps;

	const defaultDetailsModalProps = {
		enableButton: false,
	} as ModalProps;

	useEffect(() => {
		//@ts-ignore
		if (user?.authenticated == true) setUsername(user['payload']['cognito:username']);
	}, [user]);

	const handleApprove = async (paymentId: string) => {
		let modalData = stateRef.current;
		await servicesBeneficiary.generateSessionId(username, modalData.password, userPoolId, cognitoClientId).then((sessionId) => {
			const data = {
				bankAccountId,
				payload: {
					action: "Approve", sessionId: sessionId, code: modalData.code
				},
				paymentId,
				path: "Beneficiary"
			} as ParamsApproveOrReject;

			servicesBeneficiary.approveOrReject(data).then(() => Toast.showSuccessMessage("Favorecido aprovado com sucesso!"))
				.finally(() => { tableRef.current.onQueryChange(); handleClose(); });
		});
	};

	const handleReject = async (paymentId: string) => {
		let modalData = stateRef.current;
		await servicesBeneficiary.generateSessionId(username, modalData.password, userPoolId, cognitoClientId).then((sessionId) => {
			const data = {
				bankAccountId,
				payload: {
					action: "Reject", sessionId: sessionId, code: modalData.code
				},
				paymentId,
				path: "Beneficiary"
			} as ParamsApproveOrReject;

			servicesBeneficiary.approveOrReject(data).then(() => Toast.showSuccessMessage("Favorecido reprovado com sucesso!"))
				.finally(() => { tableRef.current.onQueryChange(); handleClose(); });
		});
	};

	const handleCancel = async (beneficiaryId: string) => {
		let modalData = stateRef.current;
		await servicesBeneficiary.generateSessionId(username, modalData.password, userPoolId, cognitoClientId).then((sessionId) => {
			const data = {
				bankAccountId,
				beneficiaryId,
				sessionId,
				passCode: modalData.code,
				path: "Beneficiary"
			} as ParamsCancel;

			servicesBeneficiary.cancel(data).then(() => {
				Toast.showSuccessMessage("Favorecido cancelado com sucesso!");
				servicesBeneficiary.getBeneficiariesList(bankAccountId, { page: 0, size: 10, isDeleted: false });
			}).finally(() => { tableRef.current.onQueryChange(); handleClose(); });
		});
	};

	const handleDelete = async (userId: string) => {
		let modalData = stateRef.current;
		await servicesBeneficiary.generateSessionId(username, modalData.password, userPoolId, cognitoClientId).then((sessionId) => {
			const data = {
				bankAccountId,
				userId,
				sessionId,
				passCode: modalData.code,
				path: "Beneficiary"
			} as ParamsDelete;
			servicesBeneficiary.deleteList(data).then(() => Toast.showSuccessMessage("Favorecido excluído com sucesso!")).finally(() => { tableRef.current.onQueryChange(); handleClose(); });
		});
	};

	return (
		<ContentContainer>
			<MaterialTable
				style={{ paddingLeft: 20, paddingRight: 20, maxWidth: '91vw' }}
				tableRef={tableRef}
				title={
					<Button
						variant="outlined"
						onClick={() => setEnableFilter(!enableFilter)}
						children={"Favorecidos"}
						color="default"
						startIcon={<FilterListIcon />}
					/>
				}
				columns={[
					{ title: 'Nome', field: 'name' },
					{ title: 'CPF/CNPJ', field: 'registrationNumber', render: ({ registrationNumber }: any) => (Helper.formatDocumentNumber(registrationNumber)) },
					{
						title: 'Dados da Conta', field: 'agency',
						filtering: false,
						render: (account: BeneficiaryType) => {
							return account.agency
								&& `Ag:${account.agency}  Conta:${account.accountNumber} `;
						}
					},
					// {title: "Chave Pix", field: "keyPix", filtering: false}
					{
						title: <div style={{ fontSize: 14, minWidth: 250, display: 'inline-block', textAlign: 'left' }}>Chave Pix</div>,
						field: "keyPix",
						filtering: false,
						render: ({ pixKeyTypeValueDisplay, keyPix }: BeneficiaryType) => {
							//@ts-ignore
							return pixKeyTypeValueDisplay !== "AgencyAndAccount" && (
								<div>
									{pixKeyTypeValueDisplay === 'Telefone' ? 'Celular: ' : ''}
									{`${pixKeyTypeValueDisplay != null && pixKeyTypeValueDisplay != 'Telefone' ? pixKeyTypeValueDisplay + ':' : ''} ${keyPix != null ? keyPix : ''}`}
								</div>
							);
						},
					},
					{
						title: 'Status',
						field: 'statusDisplay',
						//@ts-ignore
						cellStyle: (_, { statusDisplay }: { statusDisplay: string }) => ({ color: HelperStatus.statusTheme(statusDisplay) }),
						filterComponent: (props) => <Select
							{...props}
							fullWidth
							//@ts-ignore
							onChange={(e) => props.onFilterChanged(props?.columnDef?.tableData?.id, e.target.value)}
						>
							<MenuItem value={""}></MenuItem>
							{optionsStatusFiltering && optionsStatusFiltering.map(field => (
								<MenuItem key={field.value} value={field.value}>{field.name}</MenuItem>
							))}
						</Select>,
					}
				]}
				actions={[
					(rowData) => {
						return {
							iconProps: { style: { color: '#5F5F5F' } },
							icon: "loupe",
							tooltip: 'Detalhes',
							position: 'row',
							onClick: async () => {
								setModalProps(
									{
										...defaultDetailsModalProps,
										title: 'Detalhes da Aprovação',
										subtitle: '',
										children: <ApproversDetails data={rowData} />
									}
								);
								handleOpen();
							}
						};
					},
					(rowData) => {
						return {
							iconProps: { style: { color: '#5F5F5F' } },
							icon: "thumb_up",
							tooltip: 'Aprovar',
							position: 'row',
							hidden: rowData.statusDisplay !== "Aguardando aprovação",
							onClick: async (_, rowData: any) => {
								handleOpen();
								setModalProps(
									{
										...defaultModalProps,
										onClick: () => handleApprove(rowData.id),
									}
								);
							}
						};
					},
					(rowData) => {
						return {
							iconProps: { style: { color: '#5F5F5F' } },
							icon: "thumb_down",
							tooltip: 'Reprovar',
							position: 'row',
							hidden: rowData.statusDisplay !== "Aguardando aprovação",
							onClick: async (_, rowData: any) => {
								handleOpen();
								setModalProps(
									{
										...defaultModalProps,
										title: 'Reprovar Favorecido',
										subtitle: 'Tem certeza que deseja  reprovar o favorecido?',
										onClick: () => handleReject(rowData.id),
									}
								);

							}
						};
					},
					(rowData) => {
						return {
							iconProps: { style: { color: '#ff0000' } },
							icon: "cancel",
							tooltip: 'Cancelar',
							position: 'row',
							hidden: rowData.statusDisplay !== "Aguardando aprovação",
							onClick: (_, rowData: any) => {
								handleOpen();
								setModalProps(
									{
										...defaultModalProps,
										title: 'Cancelar Favorecido',
										subtitle: 'Tem certeza que deseja cancelar o favorecido?',
										onClick: () => handleCancel(rowData.id),
									}
								);
							}
						};
					}
				]}
				editable={{
					onRowDelete: oldData =>
						new Promise(async resolve => {
							handleOpen();
							setModalProps(
								{
									...defaultModalProps,
									title: "Remover favorecido",
									subtitle: 'Tem certeza que deseja remover o favorecido da conta?',
									//@ts-ignore
									onClick: () => handleDelete(oldData?.id)
								}
							);
							resolve('');
						})
				}}
				data={(allParams) =>
					new Promise((resolve, reject) => {
						const { page, pageSize, search, filters, orderBy, orderDirection } = allParams;

						const filtersValues = {

							f_name: enableFilter && filters.find(f => f.column.field === 'name')?.value,
							f_registrationNumber: enableFilter && filters.find(f => f.column.field === 'registrationNumber')?.value,
							f_status: enableFilter && enableFilter && filters.find(f => f.column.field === 'statusDisplay')?.value,
							page,
							size: pageSize,
							searchString: search,
							orderByField: orderBy?.field,
							orderByDirection: orderDirection,
							isDeleted: false
						};

						servicesBeneficiary.getBeneficiariesList(bankAccountId, filtersValues).then((result) => {
							const { data } = result;

							if (data)
								resolve({
									//@ts-ignore
									data: data,
									page: result.page,
									totalCount: result.totalItems,
								});
							else {
								resolve({
									data: [],
									page: 0,
									totalCount: 0,
								});
							}
						}).catch(err => reject(err));
					})
				}
				onChangeRowsPerPage={onRowsPerPageChange}
				onRowsPerPageChange={onRowsPerPageChange}
				localization={{
					...localizationOptions,
					header: {
						actions: 'Ações'
					}
				}}
				components={{
					Pagination: props => (
						<TablePagination
							{...props}
							rowsPerPageOptions={[5, 10, 20, 50]}
						/>
					),
				}}
				options={{
					actionsColumnIndex: -1,
					pageSize: rowsPerPage,
					debounceInterval: 500,
					searchAutoFocus: true,
					doubleHorizontalScroll: false,
					filtering: enableFilter
				}}
			/>
		</ContentContainer>
	);
};

export default FavoredList;
